<template>
  <div class="osp-report-box">
    <!-- 导航提示标题 -->
    <ml-tip :showHeader="false" content="运维报告" />
    <!-- 搜索框 -->
    <ml-tip :showHeader="false" style="border: 0">
      <ml-form inline labelWidth="90px" :model="searchData" ref="searchDataRef">
        <!-- 阿米巴 -->
        <ml-select
          prop="companyId"
          placeholder="请选择阿米巴"
          :options="unitOptions"
          label="阿米巴:"
          keyName="companyId"
          labelName="companyName"
          valueName="companyId"
          v-model="searchData.companyId"
          style="margin-bottom: 0"
          @change="selectUnit"
        />
        <!-- 所属项目 -->
        <ml-select
          prop="projectId"
          placeholder="请选所属项目"
          :options="projectData"
          label="所属项目:"
          keyName="projectId"
          labelName="projectName"
          valueName="projectId"
          v-model="searchData.projectId"
          :style="{ marginBottom: 0 }"
          @change="searchFn"
        />
        <!-- 日期 -->
        <ml-date-picker
          prop="reportTime"
          placeholder="报告日期"
          label="报告日期:"
          type="month"
          value-format="YYYY-MM"
          v-model="searchData.reportTime"
          @change="searchFn"
          :style="{ marginBottom: 0, marginRight: '40px' }"
        />
        <!-- 搜索按钮 -->
        <ml-button
          :style="{ 'margin-bottom': 0 }"
          submitText="搜索"
          submitIcon="el-icon-search"
          cancelText="重置"
          cancelIcon="el-icon-refresh"
          cancelType="danger"
          @click-cancel="resetSearchData"
          @click-submit="searchFn"
        />
        <!-- 按钮 -->
        <ml-button
          :style="{ 'margin-bottom': 0 }"
          submitText="生成报告"
          submitIcon="el-icon-download"
          @click-submit="exportReport"
          :showCancel="false"
        />
      </ml-form>
    </ml-tip>
    <ml-tip :showHeader="false" class="default-tip" style="margin-bottom: 0">
      <el-table :data="tabberData.data" style="width: 100%" :height="tabberHeight(319)">
        <el-table-column align="center" type="index" width="80">
          <template #default="scope">
            {{ (tabberData.page - 1) * tabberData.size + (scope.$index + 1) }}
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          align="center"
          label="所属阿米巴"
          prop="companyName"
          min-width="25%"
        />
        <el-table-column
          show-overflow-tooltip
          align="center"
          label="所属项目"
          prop="projectName"
          min-width="35%"
        />
        <el-table-column
          show-overflow-tooltip
          align="center"
          label="报告日期"
          prop="reportTime"
          min-width="15%"
        />
        <el-table-column align="center" label="操作" priop="planId" min-width="25%">
          <template #default="scope">
            <el-button size="mini" icon="el-icon-view" type="success" @click="clickView(scope.row)">
              在线预览
            </el-button>
            <el-dropdown
              style="margin-left: 10px"
              split-button
              type="primary"
              size="mini"
              @command="$event => handleClick(scope.row, $event)"
            >
              导出
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item command="1">pdf</el-dropdown-item>
                  <el-dropdown-item command="2">word</el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <ml-pagination
        :total="tabberData.total"
        :page="tabberData.page"
        v-model="tabberData.page"
        :size="tabberData.size"
        @current-change="currentChange"
        @size-change="sizeChange"
      />
    </ml-tip>
  </div>
</template>
<script>
import { computed, onMounted, reactive, ref, watch } from 'vue'
import { tabberHeight, searchParams, getTabberData, clearMemoryPageFn, downloadFile } from '@/utils'
import { useStore } from 'vuex'
import { reportPreview, exportReportRequest } from '@/API/previewApi'
import { useRouter } from 'vue-router'
export default {
  name: 'opsReport',
  setup() {
    const router = useRouter()
    const { commit, getters, dispatch } = useStore()
    const isBusinessDepartment = computed(() => getters.isBusinessDepartment)
    const getMemoryPage = computed(() => getters.getMemoryPage)
    /* 开始 搜索 **********************************/
    // 搜索条件
    const searchDataRef = ref()
    const searchData = reactive({
      reportTime: getMemoryPage.value.searchData.reportTime || '',
      companyId: getMemoryPage.value.searchData.companyId || '',
      projectId: getMemoryPage.value.searchData.projectId || '',
      reportType: ''
    })
    // 单位配置
    const unitOptions = ref([])
    // 所属项目配置
    const projectData = ref([])
    const iframeUrl = ref('')
    // 处理所属项目
    const getProjectData = async companyId => {
      const projectParams = {}
      if (isBusinessDepartment.value && companyId) {
        projectParams.companyId = companyId
      }
      const { data } = await getTabberData(dispatch, 'fetchGetProjectsByCompany', projectParams)
      projectData.value = data || []
    }
    const selectUnit = () => {
      searchData.projectId = ''
      searchFn()
    }
    watch(
      () => searchData.companyId,
      newvalue => {
        if (newvalue) {
          getProjectData(newvalue)
        }
      }
    )
    // 重置搜索内容
    const resetSearchData = () => {
      searchDataRef.value.CustomFormRef.resetFields()
      clearMemoryPageFn(commit, searchData)
      tabberData.page === 1 ? getOpsReportList() : (tabberData.page = 1)
    }
    // 搜索
    const searchFn = () => {
      tabberData.page === 1 ? getOpsReportList() : (tabberData.page = 1)
    }

    /* 开始 数据列表 **********************************/
    // 表格配置
    const tabberData = reactive({
      data: [],
      total: 0,
      page: getMemoryPage.value.page || 1,
      size: getMemoryPage.value.size || 10
    })
    // 获取列表
    const getOpsReportList = async (
      params = { pageIndex: tabberData.page, pageSize: tabberData.size }
    ) => {
      const searchDataParams = searchParams(searchData)
      const { data, total } = await getTabberData(
        dispatch,
        'fetchGetOpsReport',
        params,
        searchDataParams
      )
      tabberData.data = data || []
      tabberData.total = total || 0
    }
    //分页事件
    watch([() => tabberData.page, () => tabberData.size], () => {
      getOpsReportList()
    })
    const currentChange = page => {
      tabberData.page = page
    }
    const sizeChange = size => {
      tabberData.size = size
    }

    const exportReport = () => {
      router.push('/opsReportAction')
    }

    const clickView = item => {
      let params = {
        reportId: item.reportId
      }
      reportPreview(params).then(res => {
        const blob = new Blob([res.data], { type: 'application/pdf' })
        iframeUrl.value = window.URL.createObjectURL(blob)
        window.open(`${iframeUrl.value}`)
      })
    }

    const exportHandle = async (item, exportType) => {
      let params = {
        reportId: item.reportId,
        exportType
      }
      exportReportRequest(params).then(res => {
        let fileName = item.projectName + '.pdf'
        if (exportType == 2) {
          fileName = item.projectName + '.doc'
        }
        downloadFile(res.data, fileName)
      })
    }

    const handleClick = (item, command) => {
      exportHandle(item, command)
    }

    /* 结束 数据列表 **********************************/
    onMounted(async () => {
      // 获取单位名
      const { data } = await getTabberData(dispatch, 'fetchGetCompanyInfos', {
        noCompanyCode: 'business_department'
      })
      unitOptions.value = data || []

      getOpsReportList()
    })
    return {
      searchDataRef,
      searchData,
      unitOptions,
      projectData,
      selectUnit,
      resetSearchData,
      searchFn,
      tabberHeight,
      tabberData,
      currentChange,
      sizeChange,
      exportReport,
      clickView,
      iframeUrl,
      exportHandle,
      handleClick
    }
  }
}
</script>
<style lang="scss" scoped>
.osp-report-box {
  @extend %params-global;
  .el-input__inner {
    width: 170px;
  }
}
</style>